module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/classically-trained/"},"frontmatter":{"title":"Classically trained. Which modern cars will be retro icons in 2040?","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450-articletitle-header-image-v2-3a98f4247ecac5f974a3ba6bda37fa0a.jpg"}}},"original":"/img/1160x450-articletitle-header-image-v2.jpg"},"category":"Culture"}}}]}},"pathContext":{"tag":"classic"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-classic.json
// module id = 1812
// module chunks = 129079056812157